export const ERROR_DESCRIPTION_FETCHED = 'ERROR_DESCRIPTION_FETCHED';
